export default __webpack_public_path__ + "static/images/36049a06d99c29b6cf586a77fc60fd81.png";